import { Typography } from '@ace-clublabs/shared-component-library';
import { DateTime } from 'luxon';

type ISOString = string;
interface MaintenanceProps {
  startDate: ISOString;
  endDate: ISOString;
}

const Maintenance: React.FC<MaintenanceProps> = (props) => {
  const fromDate = DateTime.fromISO(props.startDate, { zone: 'America/New_York' });
  const toDate = DateTime.fromISO(props.endDate, { zone: 'America/New_York' });
  let fromDateFormatted = fromDate.toFormat('LLLL dd, yyyy, h:mm a');
  let toDateFormatted = toDate.toFormat('LLLL dd, yyyy');
  let toDateTime = toDate.toFormat('h:mm a');

  const message = `Our systems are down for planned maintenance from ${fromDateFormatted}. (EST) to ${toDateFormatted} at ${toDateTime}. (EST). We apologize for the inconvenience.`;

  const formattedMessage = message.replace('PM.', 'p.m.').replace('AM.', 'a.m.');

  return (
    <>
      <Typography id="maintenance">{formattedMessage}</Typography>
    </>
  );
};

export { Maintenance };
